import { connect } from 'react-redux';

import Menu from '../components/Menu';

const mapStateToProps = state => {
	return {
		recent: state.data.menu.recent
	};
};

export default connect ( mapStateToProps )( Menu );